import Hero from "./Home/Hero";
import WhoWeServe from "./Home/WhoWeServe";
import HowItWorks from "./Home/HowItWorks";
import ForgeEcosystem from "./Home/ForgeEcosystem";
import About from "./Home/About";
import CommunityImpact from "./Home/CommunityImpact";
import CTAsec from "./Home/CTAsec";
import Footer from "./Home/Footer";
import useLenis from "./useLenis";
import "./master.css";

export default function Main() {
  useLenis();
  return (
    <>
      <Hero />
      <WhoWeServe />
      <HowItWorks />
      <ForgeEcosystem />
      <About />
      <CommunityImpact />

      <CTAsec />
      <Footer />
    </>
  );
}
